
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { showSuccessToast, showErrorToast } from "@/utils/toast-utils";

interface JobManagementProps {
  jobId: string;
  organizationId: string;
  status: string;
}

export const JobManagement = ({ jobId, organizationId, status }: JobManagementProps) => {
  const handlePublish = async () => {
    try {
      const { error } = await supabase
        .from('tests')
        .update({ status: 'published' })
        .eq('id', jobId)
        .eq('creator_id', organizationId);

      if (error) throw error;

      showSuccessToast({
        description: "Test published successfully"
      });
    } catch (error: any) {
      showErrorToast({
        description: error.message
      });
    }
  };

  const handleUnpublish = async () => {
    try {
      const { error } = await supabase
        .from('tests')
        .update({ status: 'draft' })
        .eq('id', jobId)
        .eq('creator_id', organizationId);

      if (error) throw error;

      showSuccessToast({
        description: "Test unpublished successfully"
      });
    } catch (error: any) {
      showErrorToast({
        description: error.message
      });
    }
  };

  return (
    <div className="flex gap-2">
      <Button variant="outline" asChild>
        <Link to={`/test/${jobId}/edit`}>Edit Test</Link>
      </Button>
      {status === 'draft' ? (
        <Button onClick={handlePublish}>Publish</Button>
      ) : (
        <Button variant="destructive" onClick={handleUnpublish}>
          Unpublish
        </Button>
      )}
    </div>
  );
};
